// extracted by mini-css-extract-plugin
export var filterIncDec = "_38-0";
export var leftBorder = "_38-1";
export var rightBorder = "_38-2";
export var stringInput = "_38-3";